export var Microsoft365GroupMemberSortField;
(function (Microsoft365GroupMemberSortField) {
    Microsoft365GroupMemberSortField["MICROSOFT365_GROUP_MEMBER_SORT_FIELD_DISPLAY_NAME"] = "DISPLAY_NAME";
    Microsoft365GroupMemberSortField["MICROSOFT365_GROUP_MEMBER_SORT_FIELD_USER_PRINCIPAL_NAME"] = "USER_PRINCIPAL_NAME";
    Microsoft365GroupMemberSortField["MICROSOFT365_GROUP_MEMBER_SORT_FIELD_MAIL"] = "MAIL";
})(Microsoft365GroupMemberSortField || (Microsoft365GroupMemberSortField = {}));
